import { render, staticRenderFns } from "./AlternativeButton.vue?vue&type=template&id=1a79aee0&"
import script from "./AlternativeButton.vue?vue&type=script&lang=js&"
export * from "./AlternativeButton.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeButton.vue?vue&type=style&index=0&id=1a79aee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports